import React, { Component } from "react";

export default class Pov extends Component {
  render() {
    return (
      <section class="privacy-page">
        <div class="container">
          <div class="privacy-header">
            <h1>Política de Privacidad</h1>
            <p class="last-updated">
              Última actualización: 5 de diciembre, 2025
            </p>
          </div>

          <div class="privacy-content">
            <div class="privacy-section">
              <h2>1. Introducción</h2>
              <p>
                En CandyCam ("nosotros", "nuestro" o "la Plataforma"), su
                privacidad es nuestra prioridad. Esta Política de Privacidad
                describe cómo recopilamos, usamos, almacenamos y protegemos su
                información personal cuando utiliza nuestros servicios de
                streaming en vivo.
              </p>

              <p>
                Al utilizar CandyCam, usted acepta las prácticas descritas en
                esta Política de Privacidad. Si no está de acuerdo con esta
                política, por favor, no utilice nuestros servicios.
              </p>
            </div>

            <div class="privacy-section">
              <h2>2. Información que Recopilamos</h2>

              <h3>2.1. Información que Usted Proporciona</h3>
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Tipo de Datos</th>
                    <th>Ejemplos</th>
                    <th>Propósito</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Datos de Registro</td>
                    <td>Nombre, email, fecha de nacimiento, género</td>
                    <td>Crear y gestionar su cuenta</td>
                  </tr>
                  <tr>
                    <td>Información de Perfil</td>
                    <td>Foto de perfil, biografía, intereses</td>
                    <td>Personalizar su experiencia</td>
                  </tr>
                  <tr>
                    <td>Contenido de Streaming</td>
                    <td>Mensajes de chat, regalos virtuales</td>
                    <td>Proveer el servicio de streaming</td>
                  </tr>
                </tbody>
              </table>

              <h3>2.2. Información Recopilada Automáticamente</h3>
              <ul>
                <li>
                  <strong>Datos Técnicos:</strong> Dirección IP, tipo de
                  dispositivo, sistema operativo
                </li>
                <li>
                  <strong>Datos de Conexión:</strong> ubicación aproximada
                  (basada en IP)
                </li>
              </ul>

              <div class="highlight-box">
                <p>
                  <strong>Nota sobre Ubicación:</strong> Solo recopilamos
                  ubicación aproximada basada en IP para mejorar la experiencia.
                </p>
              </div>
            </div>

            <div class="privacy-section">
              <h2>3. Tecnología P2P y Protección de Datos</h2>

              <h3>3.1. Transmisiones Peer-to-Peer</h3>
              <p>
                CandyCam utiliza tecnología peer-to-peer (P2P) para las
                transmisiones en vivo. Esto significa:
              </p>
              <ul>
                <li>
                  Las transmisiones fluyen directamente entre usuarios sin pasar
                  por nuestros servidores
                </li>
                <li>
                  Mayor privacidad al reducir puntos centralizados de datos
                </li>
                <li>
                  Calidad de transmisión depende de la conexión de cada usuario
                </li>
              </ul>

              <h3>3.2. Protección Anticapturas</h3>
              <p>
                Implementamos tecnología para prevenir capturas de pantalla
                durante transmisiones, protegiendo:
              </p>
              <ul>
                <li>Contenido de creadores contra copias no autorizadas</li>
                <li>Privacidad de espectadores en chats de vídeo</li>
                <li>Integridad de las interacciones en tiempo real</li>
              </ul>

              <div class="highlight-box">
                <p>
                  <strong>Limitaciones y Advertencias:</strong>
                </p>
                <ul>
                  <li>
                    Las protecciones son{" "}
                    <strong>preventivas, no garantías absolutas</strong>
                  </li>
                  <li>
                    El contenido publicado ó transmitido se considera{" "}
                    <strong>público</strong>
                  </li>
                  <li>
                    CandyCam <strong>no se responsabiliza</strong> por capturas
                    o distribución no autorizada
                  </li>
                  <li>
                    Consulte la sección completa en{" "}
                    <a href="/tos#proteccion-anticapturas" class="legal-link">
                      Términos de Servicio
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="privacy-section">
              <h2>4. Cómo Usamos su Información</h2>

              <table class="data-table">
                <thead>
                  <tr>
                    <th>Propósito</th>
                    <th>Tipo de Datos</th>
                    <th>Base Legal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Personalizar experiencia</td>
                    <td>Datos de uso, preferencias</td>
                    <td>Interés legítimo</td>
                  </tr>
                  <tr>
                    <td>Mejorar la Plataforma</td>
                    <td>Datos técnicos, de uso</td>
                    <td>Interés legítimo</td>
                  </tr>
                  <tr>
                    <td>Comunicaciones</td>
                    <td>Email, preferencias</td>
                    <td>Consentimiento</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="privacy-section">
              <h2>5. Con Quién Compartimos su Información</h2>

              <h3>5.1. Otros Usuarios</h3>
              <p>
                Según su configuración de privacidad, cierta información puede
                ser visible para:
              </p>
              <ul>
                <li>Otros espectadores en las mismas transmisiones</li>
                <li>Creadores que siga o con los que interactúe</li>
                <li>Usuarios en su lista de amigos</li>
              </ul>
            </div>

            <div class="privacy-section">
              <h2>6. Retención de Datos</h2>

              <p>
                Conservamos su información personal solo durante el tiempo
                necesario:
              </p>

              <table class="data-table">
                <thead>
                  <tr>
                    <th>Tipo de Datos</th>
                    <th>Período de Retención</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Datos de cuenta activa</td>
                    <td>Mientras la cuenta esté activa</td>
                  </tr>
                  <tr>
                    <td>Transmisiones en vivo</td>
                    <td>No se almacenan (tecnología P2P)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="privacy-section">
              <h2>7. Menores de Edad</h2>

              <p>
                CandyCam no está dirigido a menores de 18 años. No recopilamos
                conscientemente información de menores.
              </p>

              <div class="highlight-box">
                <p>
                  <strong>Verificación de Edad:</strong> Implementamos medidas
                  para verificar la edad durante el registro. Si descubre que un
                  menor nos ha proporcionado datos, contáctenos inmediatamente.
                </p>
              </div>
            </div>

            <div class="privacy-section">
              <h2>8. Cambios a esta Política</h2>

              <p>
                Podemos actualizar esta Política de Privacidad periódicamente.
                Le notificaremos sobre cambios significativos mediante:
              </p>
              <ul>
                <li>Email a la dirección registrada</li>
                <li>Aviso prominente en la Plataforma</li>
                <li>Actualización de la fecha "Última actualización"</li>
              </ul>

              <p>
                El uso continuado de CandyCam después de cambios constituye
                aceptación de la nueva política.
              </p>
            </div>
          </div>

          <div class="highlight-box">
            <p>
              <strong>Resumen Clave:</strong> CandyCam prioriza su privacidad
              mediante tecnología P2P, opciones de control robustas. Usted
              controla qué información comparte.
            </p>
          </div>
        </div>
      </section>
    );
  }
}
